import { type FunctionComponent, useState } from 'react';
import {
  EuiButton,
  EuiConfirmModal,
  EuiToolTip,
  useGeneratedHtmlId,
} from '@elastic/eui';
import useRevokeAll from '@data/revoke-all';
import type { Person } from '@domain/person';
import { css } from '@emotion/react';

interface RevokeAllProps {
  person: Person;
}

const RevokeAll: FunctionComponent<RevokeAllProps> = ({ person }) => {
  const { idnumber, firstname, surname } = person;
  const [revokeAll, { loading }] = useRevokeAll();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const closeModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);
  const modalTitleId = useGeneratedHtmlId();

  const handleClick = () => {
    revokeAll(idnumber).then(() => closeModal());
  };

  return (
    <>
      <EuiToolTip content="Revoke all group and georole permissions">
        <EuiButton
          color="danger"
          iconType="crossInCircle"
          onClick={showModal}
          isLoading={loading}>
          Revoke all permissions
        </EuiButton>
      </EuiToolTip>

      {isModalVisible && (
        <EuiConfirmModal
          aria-labelledby={modalTitleId}
          title="Revoke all permissions?"
          titleProps={{ id: modalTitleId }}
          onCancel={closeModal}
          onConfirm={handleClick}
          cancelButtonText="Cancel"
          confirmButtonText="Revoke all"
          buttonColor="danger"
          defaultFocusedButton="confirm"
          isLoading={loading}>
          <p>
            Are you sure you want to revoke{' '}
            <span
              css={css`
                font-weight: bold;
              `}>
              all permissions
            </span>{' '}
            for {firstname} {surname}? This action cannot be undone.
          </p>
        </EuiConfirmModal>
      )}
    </>
  );
};

export default RevokeAll;
